import Bottom from './components/Bottom';
import Img from './components/Img';
import Top from './components/Top';
import * as styles from './styles';

export default function Footer() {
  return (
    <styles.Container>
      <Img />
      <Top />
      <Bottom />
    </styles.Container>
  );
}
